import React from 'react'
import { colors } from '@fs/zion-ui'

export default function MenuTemple({ selected = false, fillColor = colors.blue80 }) {
  return (
    <svg width="24" height="24" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 22H1V13.8182L6 12H14L19 13.8182V22Z"
        stroke={selected ? fillColor : colors.gray100}
        strokeOpacity={selected ? 1 : 0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 13V7M8 12V6H12V12"
        stroke={selected ? fillColor : colors.gray100}
        strokeOpacity={selected ? 1 : 0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12V22M14 12.5V22"
        stroke={selected ? fillColor : colors.gray100}
        strokeOpacity={selected ? 1 : 0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 13V7"
        stroke={selected ? fillColor : colors.gray100}
        strokeOpacity={selected ? 1 : 0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6V1"
        stroke={selected ? fillColor : colors.gray100}
        strokeOpacity={selected ? 1 : 0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
